import { APPLICATION_STATUS } from "@/queries/provider-onboarding/application-status";

export const TOTAL_STEPS = 5;
export const PROVIDER_TYPE = "deluxe";

export const getMerchantStepPath = (step: number, applicationId?: string) => {
  const base = `/invoices/settings/merchant/${step}`;
  return applicationId ? `${base}?app_id=${applicationId}` : base;
};

export const MERCHANT_EXIT_PATH = "/invoices/settings";
export const MERCHANT_LANDING_PATH = "/invoices/settings/merchant";

export const getResumeStep = (status: string, applicationId: string): string => {
  switch (status) {
    case APPLICATION_STATUS.APPLICATION_CREATED:
    case APPLICATION_STATUS.IDENTITY_VERIFICATION:
    case APPLICATION_STATUS.IDENTITY_VERIFICATION_SUBMITTED:
      return getMerchantStepPath(2, applicationId);
    case APPLICATION_STATUS.ACCEPT_FEES:
    case APPLICATION_STATUS.ACCEPTED_FEES:
    case APPLICATION_STATUS.ACCEPT_TERMS_AND_CONDITIONS:
    case APPLICATION_STATUS.ACCEPTED_TERMS_AND_CONDITIONS:
      return getMerchantStepPath(4, applicationId);
    case APPLICATION_STATUS.APPLICATION_SUBMITTED:
    case APPLICATION_STATUS.APPLICATION_APPROVED:
    case APPLICATION_STATUS.APPLICATION_REJECTED:
    case APPLICATION_STATUS.APPLICATION_NEEDS_INFO:
      return getMerchantStepPath(5, applicationId);
    default:
      return getMerchantStepPath(1);
  }
};
